import { render, staticRenderFns } from "./AuthSetPasswordForm.vue?vue&type=template&id=ed4ba1e8"
import script from "./AuthSetPasswordForm.vue?vue&type=script&lang=js"
export * from "./AuthSetPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports